import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    Spinner,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { createRegion } from './redux/dispatcher';

const AddRegion = () => {
    const dispatch = useDispatch();
    const regionListState = useSelector((state) => state.regionListReducer);
    const [modal, setModal] = useState(false);

    const toggleModal = () => {
        setModal(!modal);
        formik.resetForm();
    };

    const validationSchema = yup.object().shape({
        name: yup
            .string()
            .min(2, 'Name must be at least 2 characters')
            .max(100, 'Name must be less than 100 characters')
            .required('Please enter region name.'),
        address: yup
            .string()
            .min(2, 'Address must be at least 2 characters')
            .max(255, 'Address must be less than 255 characters')
            .required('Please enter region address.')
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            address: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            dispatch(createRegion(values, toggleModal));
        }
    });

    return (
        <div>
            <Button className="btn-primary" onClick={toggleModal} style={{ whiteSpace: 'nowrap' }}>
                + Add Region
            </Button>
            <Modal isOpen={modal} toggle={toggleModal} centered size="lg">
                <ModalHeader toggle={toggleModal}>Add New Region</ModalHeader>
                <Form onSubmit={formik.handleSubmit}>
                    <ModalBody>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="name">
                                        Region Name <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        id="name"
                                        placeholder="Enter region name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.name && Boolean(formik.errors.name)}
                                    />
                                    {formik.touched.name && formik.errors.name && (
                                        <FormFeedback>{formik.errors.name}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="address">
                                        Address <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="text"
                                        name="address"
                                        id="address"
                                        placeholder="Enter region address"
                                        value={formik.values.address}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.address && Boolean(formik.errors.address)}
                                    />
                                    {formik.touched.address && formik.errors.address && (
                                        <FormFeedback>{formik.errors.address}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn-primary" type="submit" disabled={regionListState?.isLoading}>
                            {regionListState?.isLoading ? <Spinner size="sm" /> : 'Save'}
                        </Button>{' '}
                        <Button color="secondary" onClick={toggleModal}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </div>
    );
};

export default AddRegion;
